import axios from 'axios';

export default axios.create({
  baseURL: 'https://cinetica-h3n8q.ondigitalocean.app'
});